import 'babel-polyfill';
import 'element-remove';
import 'url-search-params-polyfill';
import moment from 'moment';
import 'moment/locale/de';
import React, { Component, Fragment } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import 'react-tippy/dist/tippy.css';
import '../styles/shared.scss';
import BikeInsurance from './containers/BikeInsurance';
import ClientAdvisorContainer from './containers/ClientAdvisorContainer';
import CustomerCenterContainer from './containers/CustomerCenterContainer';
import RegistrationOfficeContainer from './containers/RegistrationOfficeContainer';
import PaymentFormMkContainer from './containers/PaymentFormMkContainer';
import TravelInsurance from './containers/TravelInsurance';
import ExpertInterpreter from './containers/ExpertInterpreterInsurance';
import { BENEFIT_MOCK } from './utils/mock';
import PromInsurance from './containers/PromInsurance';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Set the global moment() locale to DE-AT
moment.locale('de-AT');

const bike = 'bike';
const travel = 'vacation';
const customerCenter = 'customerCenter';
const customerAdvisor = 'customerAdvisor';
const registrationOffice = 'registrationOffice';
const paymentFormMk = 'paymentFormMk';
const prom = 'prom';
const expertInterpreter = 'expertInterpreter';

let GRAWE;
if (process.env && process.env.REACT_APP_INSURANCE_TYPE) {
  GRAWE = {
    insurance_type: process.env.REACT_APP_INSURANCE_TYPE
  };

  if (process.env.REACT_APP_COUNTRY) {
    GRAWE.country = process.env.REACT_APP_COUNTRY;
  }
}

class App extends Component {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const form = document.getElementById('insurance-form') || document.getElementById('confirmation-wrapper');
    let footer = document.getElementsByClassName('sticky-footer');

    if (!!form && !!footer) {
      footer = footer.item(0);

      const formTop = form.offsetTop;
      const formHeight = form.offsetHeight;
      const formPosition = formTop + formHeight;

      const scrollTop = window.scrollY;
      const windowHeight = window.outerHeight;
      const scrollPosition = scrollTop + windowHeight;

      const footerHeight = footer.clientHeight;

      if (formPosition < scrollPosition - footerHeight) {
        footer.classList.add('static');
      } else if (formPosition > scrollPosition) {
        footer.classList.remove('static');
      }
    }
  }

  render() {
    let Component;
    let wrapperClassName = 'forms-app';

    if (window.insuranceType === bike || (GRAWE && GRAWE.insurance_type === bike)) {
      Component = BikeInsurance;
    } else if (window.insuranceType === travel || (GRAWE && GRAWE.insurance_type === travel)) {
      Component = TravelInsurance;
    } else if (window.insuranceType === customerCenter || (GRAWE && GRAWE.insurance_type === customerCenter)) {
      Component = CustomerCenterContainer;
      wrapperClassName = 'forms-app-locations forms-app-customer-center';
    } else if (window.insuranceType === customerAdvisor || (GRAWE && GRAWE.insurance_type === customerAdvisor)) {
      Component = ClientAdvisorContainer;
      wrapperClassName = 'forms-app-locations forms-app-customer-advisor';
    } else if (window.insuranceType === registrationOffice || (GRAWE && GRAWE.insurance_type === registrationOffice)) {
      Component = RegistrationOfficeContainer;
      wrapperClassName = 'forms-app-locations forms-app-registration-office';
    } else if (window.insuranceType === paymentFormMk || (GRAWE && GRAWE.insurance_type === paymentFormMk)) {
      Component = PaymentFormMkContainer;
    } else if (window.insuranceType === expertInterpreter || (GRAWE && GRAWE.insurance_type === expertInterpreter)) {
      Component = ExpertInterpreter;
    } else if (window.insuranceType === prom || (GRAWE && GRAWE.insurance_type === prom)) {
      Component = PromInsurance;
    }

    const basename = window.base ? '#' : '/#';
    window.base = basename;

    if (!window.benefits) {
      window.benefits = BENEFIT_MOCK;
    }

    if (!window.appCountry && GRAWE && GRAWE.country) {
      window.appCountry = GRAWE.country;
    }

    return (
      <Fragment>
        <ToastContainer
          pauseOnFocusLoss={false}
          position="bottom-center"
          className="custom-toast"
          theme="colored"
          icon={false}
        />
        <div className={wrapperClassName}>
          <div className="container">
            <Router>
              <Routes>
                <Route path="/*" element={<Component />} />
              </Routes>
            </Router>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default App;
